var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import './styles.css';
var Select = function (props) {
    var _a, _b;
    var values = props.values, valueMember = props.valueMember, displayMember = props.displayMember, onChange = props.onChange, disabled = props.disabled;
    var handleChange = function (event) {
        if (!onChange)
            return;
        var rawValue = event.target.value;
        var parsedValue = rawValue === ''
            ? ''
            : isNaN(Number(rawValue))
                ? rawValue
                : Number(rawValue);
        // 🔥 evento compatível com Formik
        onChange({
            target: {
                name: event.target.name,
                value: parsedValue
            }
        });
    };
    return (_jsxs("div", __assign({ className: "selectContainer" }, { children: [_jsxs("label", __assign({ className: "selectLabel" }, { children: [values.label, ":"] }), void 0), _jsxs("select", __assign({ name: props.name, id: (_a = props.id) !== null && _a !== void 0 ? _a : props.name, value: (_b = props.value) !== null && _b !== void 0 ? _b : '', disabled: disabled, onChange: disabled ? undefined : handleChange, className: "\n          selectInput\n          " + (props.resize ? 'selectInputWidthResized' : 'selectInputWidthDefault') + "\n          " + (disabled ? 'selectDisabled' : '') + "\n        " }, { children: [props.firstOption ? (_jsx("option", __assign({ value: "" }, { children: props.firstOption }), void 0)) : (_jsx("option", __assign({ value: "", disabled: props.notNull }, { children: "Selecione..." }), void 0)), values.options.map(function (item, index) { return (_jsx("option", __assign({ value: item[valueMember], className: "text-gray-600" }, { children: item[displayMember] }), index)); })] }), void 0)] }), void 0));
};
export default Select;
